import { useAuthenticator } from "@aws-amplify/ui-react";
import { getRedirectParameter, redirect } from "../services/redirect";
import { useEffect, useState } from "react";
import { Spinner } from "@idwal/idwal-react-components";
import { Auth } from "aws-amplify";
import { getUserInfo } from "../services/UserInfoService";
import { useNavigate } from "react-router-dom";
import { setCookie } from "../services/cookies";

/**
 * This component is responsible for rendering the correct Amplify Auth low
 * and for redirecting to the correct place after actions are complete
 * Sign out boolean can be provided to force the user to logout on load
 * @param props
 * @returns
 */
export const AuthRoute = (props: {
    children?: React.ReactNode;
    signOut?: boolean;
}) => {
    const { user } = useAuthenticator((context) => [context.user]);
    const [loading, setLoading] = useState(true);
    const redirectParam = getRedirectParameter();
    const navigate = useNavigate();

    useEffect(() => {
        // Register and reset password require the user to be logged out before the flow starts
        if (props.signOut) {
            Auth.signOut().then(() => {
                setLoading(false);
            });
        } else {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        async function authorizeUser() {
            const poolIdName = process.env.REACT_APP_AUTH_USER_POOL_ID?.split("_")[1];
            const cookieName = `idwal-${poolIdName}-acknowledgement`;
            if (user?.attributes?.email_verified) {
                const userInfo = await getUserInfo(user.username);
                if (!userInfo?.acknowledgement) {
                    await setCookie(cookieName, false, 12);
                    navigate("/terms-and-conditions", { state: redirectParam });
                } else {
                    await setCookie(cookieName, true, 12);
                    redirect(user, redirectParam);
                }
            }
        }

        if (!loading) {
            authorizeUser();
        }
    }, [user, loading]);

    return (
        <>
            {!loading ? (
                props.children
            ) : (
                <Spinner width={50} height={50}></Spinner>
            )}
        </>
    );
};
